/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef, useMemo } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import moment from 'moment-timezone';
import Cookies from 'js-cookie'

import TopBar from '../../components/TopBar';
import DeleteConfirmationPopup from '../../components/DeleteConfirmationPopup';
import AddProduct from '../../components/Order/AddProduct';
import { orderStatus, refundReasonOptions } from '../../utils/constants';
import { getAllCustomersWithoutPagination } from '../../api/customersApi';
import { getProductsWithTax } from '../../api/productsApi';
import { getOrderById, updateOrder, createOrder, deleteOrders, notifyCustomer, notifyCustomerToWhatsapp, notifyCustomerToEmail, sendDeliveryVerification } from '../../api/ordersApi';
import { getSalePersons } from '../../api/adminUser';
import RefundPopup from '../../components/Order/RefundPopup';
import DiscountPopup from '../../components/Order/DiscountPopup';
import InvoicePDF from '../../components/Invoice/InvoicePDF';

import Delete from "../../assets/images/delete.svg";
import penIcon from "../../assets/images/pen-img.svg"
import down from "../../assets/images/icondropdown.svg";
import close from '../../assets/images/close.svg';
import save from '../../assets/images/checkmark.svg'
import iconDropDown from "../../assets/images/icondropdown.svg";

import styles from './order.module.css';
import { formattedDateTime } from '../../utils/functions';
import ErrorPage from '../../components/ErrorPage';

const OrderDetail = () => {
  const { orderId } = useParams();
  const isNew = !orderId || orderId === '' || orderId === undefined;
  const navigate = useNavigate()

  // ============================================
  // ROLE-BASED ACCESS CONTROL
  // ============================================
  const userData = useMemo(() => JSON.parse(Cookies.get('adminUserData') || 'null'), [])
  const userRole = userData?.role || '';
  const userId = userData?.adminUserId || '';

  const [isAccessDenied, setIsAccessDenied] = useState(false);
  const [isCheckingAccess, setIsCheckingAccess] = useState(!isNew);

  const popupRef = useRef();
  const statusDropdownRef = useRef()
  const brandDropdownRef = useRef()
  const addProductDropdownRef = useRef()
  const refundReasonDropdownRef = useRef()
  const refundPopupRef = useRef()
  const discountPopupRef = useRef()
  const invoicePdfRef = useRef()
  const salePersonDropdownRef = useRef()

  const today = moment().format("YYYY-MM-DD");

  const [order, setOrder] = useState(isNew ? {
    products: [],
    customer: null,
    status: 'PENDING',
    discount: 0,
    refund: 0,
    billingAddress: {},
    shippingAddress: {},
    driverName: '',
    driverMobileNumber: '',
    driverVehicleNo: '',
    orderCreatedDate: new Date().toISOString(),
    expectedDeliveryDate: moment(new Date().toISOString()).add(15, 'days').toISOString(),
    handleBy: null
  } : null);

  const [productsToAdd, setProductsToAdd] = useState([{ search: "", selectedProduct: null, openDropdown: false, qty: "", unit: "", unitCost: "", hsnCode: "", cgst: 0, sgst: 0, igst: 0, categoryName: '', productId: '', unit: "", unitPlural: "", }]);
  const [errors, setErrors] = useState({});
  const [productErrors, setProductErrors] = useState([]);

  const [isBillingAddress, setIsBillingAddress] = useState(false)
  const [isShippingAddress, setIsShippingAddress] = useState(false)
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [deleteType, setDeleteType] = useState(null);
  const [deleteItemId, setDeleteItemId] = useState(null);
  const [deleteItemName, setDeleteItemName] = useState("");
  const [openStatus, setOpenStatus] = useState(false);
  const [openCustomer, setOpenCustomer] = useState(false);
  const [addNewProduct, setAddNewProduct] = useState(false);
  const [isOpenSendMailDropdown, setOpenSendMailDropdown] = useState(true);
  const [openOrderNotes, setOpenOrderNotes] = useState(true);
  const [openOrderImage, setOpenOrderImage] = useState(true);
  const [openDriverMobile, setOpenDriverMobile] = useState(true);
  const [isLoading, setIsLoading] = useState(false)
  const [customerNotifyLoader, setCustomerNotifyLoader] = useState(false)
  const [customerNotifyLoaderForWhatsapp, setCustomerNotifyLoaderForWhatsapp] = useState(false)
  const [customerNotifyLoaderForEmail, setCustomerNotifyLoaderForEmail] = useState(false)
  const [customerNotificationSent, setCustomerNotificationSent] = useState(false);
  const [customerNotificationSentToWhatsapp, setCustomerNotificationSentToWhatsapp] = useState(false);
  const [customerNotificationSentToEmail, setCustomerNotificationSentToEmail] = useState(false);
  const [deliveryVerificationLoader, setDeliveryVerificationLoader] = useState(false);

  const [discount, setDiscount] = useState(0);
  const [discountLabel, setDiscountLabel] = useState("");
  const [discountType, setDiscountType] = useState("percentage");

  const [refundAmount, setRefundAmount] = useState(0);
  const [refundType, setRefundType] = useState("partial");
  const [refundReason, setRefundReason] = useState("");

  const [openRefundReason, setOpenRefundReason] = useState(false);

  const [showRefundPopup, setShowRefundPopup] = useState(false);
  const [showDiscountPopup, setShowDiscountPopup] = useState(false);

  const [customers, setCustomers] = useState([]);
  const [customersLoading, setCustomersLoading] = useState(false);
  const [customerSearch, setCustomerSearch] = useState("");

  const [salePersons, setSalePersons] = useState([]);
  const [salePersonsLoading, setSalePersonsLoading] = useState(false);
  const [openSalePerson, setOpenSalePerson] = useState(true);
  const [openSalePersonDropdown, setOpenSalePersonDropdown] = useState(false);

  const [productsList, setProductsList] = useState([]);
  const [editingDiscount, setEditingDiscount] = useState(false);
  const [tempDiscount, setTempDiscount] = useState("");
  const discountRef = useRef();

  const [orderNotes, setOrderNotes] = useState([]);

  const [showImagePopup, setShowImagePopup] = useState(false);
  const imagePopupRef = useRef();

  const [editingCgstId, setEditingCgstId] = useState(null);
  const [editingSgstId, setEditingSgstId] = useState(null);
  const [editingIgstId, setEditingIgstId] = useState(null);
  const [tempCgst, setTempCgst] = useState(0);
  const [tempSgst, setTempSgst] = useState(0);
  const [tempIgst, setTempIgst] = useState(0);
  const [editingLineTotal, setEditingLineTotal] = useState(null);
  const [tempLineTotal, setTempLineTotal] = useState('');
  const editRef = useRef();

  // State for editing quantity
  const [editingProductId, setEditingProductId] = useState(null);
  const [tempQty, setTempQty] = useState('');
  const [editingUnitCostId, setEditingUnitCostId] = useState(null);
  const [tempUnitCost, setTempUnitCost] = useState('');
  const qtyRef = useRef();
  const unitCostRef = useRef();
  const cgstRef = useRef();
  const sgstRef = useRef();
  const igstRef = useRef();

  // State for editing item row
  const [editingItemRow, setEditingItemRow] = useState(false);
  const rowSaveRef = useRef();
  const lineTotalRef = useRef();

  const toggleDropdownSendMailImage = () => {
    setOpenSendMailDropdown(!isOpenSendMailDropdown);
  };

  // Handle address changes
  const handleBillingChange = (field, value) => {
    setOrder(prev => ({
      ...prev,
      billingAddress: { ...prev.billingAddress, [field]: value }
    }));
  };

  const handleShippingChange = (field, value) => {
    setOrder(prev => ({
      ...prev,
      shippingAddress: { ...prev.shippingAddress, [field]: value }
    }));
  };

  // Handle double-click on cgst
  const handleCgstDoubleClick = (id, value) => {
    if (editingItemRow) return;
    setEditingCgstId(id);
    setTempCgst(value || 0);
  };

  const handleSgstDoubleClick = (id, value) => {
    if (editingItemRow) return;
    setEditingSgstId(id);
    setTempSgst(value || 0);
  };

  const handleIgstDoubleClick = (id, value) => {
    if (editingItemRow) return;
    setEditingIgstId(id);
    setTempIgst(value || 0);
  };

  const handleLineTotalDoubleClick = (id, value) => {
    if (editingItemRow) return;
    setEditingLineTotal(id);
    setTempLineTotal(value?.toString() || '');
  };

  // Handle unit cost double-click
  const handleUnitCostDoubleClick = (id, value) => {
    if (editingItemRow) return;
    setEditingUnitCostId(id);
    setTempUnitCost(value?.toString() || '');
  };

  // Handle line total input change
  const handleLineTotalChange = (e) => {
    setTempLineTotal(e.target.value);
  };

  // Handle unit cost input change
  const handleUnitCostChange = (e) => {
    setTempUnitCost(e.target.value);
  };

  // Handle line total save
  const handleLineTotalSave = () => {
    const newLineTotal = parseFloat(tempLineTotal);

    if (!isNaN(newLineTotal) && newLineTotal >= 0) {
      setOrder(prev => ({
        ...prev,
        products: prev.products.map(p =>
          p.id === editingLineTotal ? { ...p, lineTotal: newLineTotal } : p
        )
      }));
    }

    setEditingLineTotal(null);
    setTempLineTotal('');
  };

  // Handle unit cost save
  const handleUnitCostSave = () => {
    const newUnitCost = parseFloat(tempUnitCost);

    if (!isNaN(newUnitCost) && newUnitCost >= 0) {
      setOrder(prev => ({
        ...prev,
        products: prev.products.map(p => {
          if (p.id === editingUnitCostId) {
            const quantity = p.quantity || 1;
            const lineTotal = newUnitCost * quantity;
            return { ...p, unitCost: newUnitCost, lineTotal: lineTotal };
          }
          return p;
        })
      }));
    }

    setEditingUnitCostId(null);
    setTempUnitCost('');
  };

  // Handler for clicking the edit (pen) button
  const itemEdit = (product) => {
    setEditingProductId(product.id);

    setTempQty(product.quantity?.toString() || '');
    setTempUnitCost(product?.unitCost?.toString() || '');
    setTempCgst(product?.cgst || 0);
    setTempSgst(product?.sgst || 0);
    setTempIgst(product?.igst || 0);
    setTempLineTotal(product?.lineTotal?.toString() || '');

    setEditingCgstId(product.id);
    setEditingSgstId(product.id);
    setEditingIgstId(product.id);
    setEditingLineTotal(product.id);
    setEditingUnitCostId(product.id);

    setEditingItemRow(true);
  };

  const saveItemEdit = () => {
    const finalQty = parseFloat(tempQty);
    const finalUnitCost = parseFloat(tempUnitCost);
    const finalCgst = parseFloat(tempCgst);
    const finalSgst = parseFloat(tempSgst);
    const finalIgst = parseFloat(tempIgst);

    setOrder(prev => ({
      ...prev,
      products: prev.products.map(p => {
        if (p.id === editingProductId) {
          const quantity = !isNaN(finalQty) ? finalQty : p.quantity;
          const unitCost = !isNaN(finalUnitCost) ? finalUnitCost : (p.unitCost || 0);
          const lineTotal = quantity * unitCost;

          return {
            ...p,
            quantity: quantity,
            unitCost: unitCost,
            hsnCode: p?.hsnCode || "",
            lineTotal: lineTotal,
            cgst: !isNaN(finalCgst) ? finalCgst : (p.cgst || 0),
            sgst: !isNaN(finalSgst) ? finalSgst : (p.sgst || 0),
            igst: !isNaN(finalIgst) ? finalIgst : (p.igst || 0),
            unit: p?.unit || "",
            unitPlural: p?.unitPlural || "",
          };
        }
        return p;
      })
    }));

    setEditingProductId(null);
    setEditingCgstId(null);
    setEditingSgstId(null);
    setEditingIgstId(null);
    setEditingLineTotal(null);
    setEditingUnitCostId(null);
    setEditingItemRow(false);

    setTempQty('');
    setTempUnitCost('');
    setTempCgst(0);
    setTempSgst(0);
    setTempIgst(0);
    setTempLineTotal('');
  };

  // Handle double-click on quantity
  const handleQtyDoubleClick = (productId, currentQty) => {
    setEditingProductId(productId);
    setTempQty(currentQty.toString());
  };

  // Handle total input change
  const handleCgstChange = (e) => {
    setTempCgst(e.target.value);
  };

  const handleSgstChange = (e) => {
    setTempSgst(e.target.value);
  };

  const handleIgstChange = (e) => {
    setTempIgst(e.target.value);
  };

  // Handle quantity input change
  const handleQtyChange = (e) => {
    setTempQty(e.target.value);
  };

  const handleCgstSave = () => {
    const newCgst = parseFloat(tempCgst);

    if (!isNaN(newCgst)) {
      setOrder(prev => ({
        ...prev,
        products: prev.products.map(p =>
          p.id === editingCgstId ? { ...p, cgst: newCgst } : p
        )
      }));
    }

    setEditingCgstId(null);
  };

  const handleSgstSave = () => {
    const newSgst = parseFloat(tempSgst);

    if (!isNaN(newSgst)) {
      setOrder(prev => ({
        ...prev,
        products: prev.products.map(p =>
          p.id === editingSgstId ? { ...p, sgst: newSgst } : p
        )
      }));
    }

    setEditingSgstId(null);
  };

  const handleIgstSave = () => {
    const newIgst = parseFloat(tempIgst);

    if (!isNaN(newIgst)) {
      setOrder(prev => ({
        ...prev,
        products: prev.products.map(p =>
          p.id === editingIgstId ? { ...p, igst: newIgst } : p
        )
      }));
    }

    setEditingIgstId(null);
  };

  // Handle outside click to save or cancel quantity
  const handleQtySave = () => {
    const newQty = parseFloat(tempQty);

    if (!isNaN(newQty) && newQty >= 0.01) {
      setOrder(prev => {
        const updatedProducts = prev.products.map(p => {
          if (p.id === editingProductId) {
            const unitCost = p.unitCost || 0;
            const lineTotal = newQty * unitCost;

            return {
              ...p,
              quantity: newQty,
              lineTotal: lineTotal,
            };
          }
          return p;
        });

        return { ...prev, products: updatedProducts };
      });
    }

    setEditingProductId(null);
    setTempQty('');
  };

  const handleDiscountDoubleClick = () => {
    setEditingDiscount(true);
    setTempDiscount(discount.toString());
  };

  const handleDiscountSave = () => {
    const value = parseFloat(tempDiscount);

    if (!isNaN(value) && value >= 0) {
      setDiscount(value);
    }

    setEditingDiscount(false);
    setTempDiscount("");
  };


  // Handle click outside
  useEffect(() => {
    const handleClickOutside = (event) => {

      // ROW EDIT MODE
      if (editingItemRow) {
        if (editRef.current && !editRef.current.contains(event.target) && qtyRef.current && !qtyRef.current.contains(event.target) && unitCostRef.current && !unitCostRef.current.contains(event.target) && rowSaveRef.current && !rowSaveRef.current.contains(event.target)) {
          saveItemEdit();
        }
        return;
      }

      // NORMAL CELL EDIT MODE
      if (cgstRef.current && !cgstRef.current.contains(event.target)) {
        handleCgstSave();
      }

      if (sgstRef.current && !sgstRef.current.contains(event.target)) {
        handleSgstSave();
      }

      if (igstRef.current && !igstRef.current.contains(event.target)) {
        handleIgstSave();
      }

      if (lineTotalRef.current && !lineTotalRef.current.contains(event.target)) {
        handleLineTotalSave();
      }

      if (unitCostRef.current && !unitCostRef.current.contains(event.target)) {
        handleUnitCostSave();
      }

      if (qtyRef.current && !qtyRef.current.contains(event.target)) {
        handleQtySave();
      }

    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [
    editingItemRow,
    editingCgstId,
    editingSgstId,
    editingIgstId,
    editingLineTotal,
    editingUnitCostId,
    editingProductId
  ]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        setShowDeletePopup(false);
      }
      if (statusDropdownRef.current && !statusDropdownRef.current.contains(event.target)) {
        setOpenStatus(false);
      }
      if (brandDropdownRef.current && !brandDropdownRef.current.contains(event.target)) {
        setOpenCustomer(false);
      }
      if (salePersonDropdownRef.current && !salePersonDropdownRef.current.contains(event.target)) {
        setOpenSalePersonDropdown(false);
      }
      if (addProductDropdownRef.current && !addProductDropdownRef.current.contains(event.target)) {
        setAddNewProduct(false);
      }
      if (refundReasonDropdownRef.current && !refundReasonDropdownRef.current.contains(event.target)) {
        setOpenRefundReason(false);
      }
      if (refundPopupRef.current && !refundPopupRef.current.contains(event.target)) {
        setShowRefundPopup(false);
      }
      if (discountPopupRef.current && !discountPopupRef.current.contains(event.target)) {
        setShowDiscountPopup(false);
      }
      if (imagePopupRef.current && !imagePopupRef.current.contains(event.target)) {
        setShowImagePopup(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showImagePopup, imagePopupRef]);

  useEffect(() => {
    const fetchCustomers = async () => {
      setCustomersLoading(true);
      try {
        const response = await getAllCustomersWithoutPagination();
        // Assuming response.data is an array of customers with id, name, email
        if (response?.data?.length > 0) {
          const customerData = response?.data?.map((item) => {
            return { ...item, name: item?.fullName }
          })
          setCustomers(customerData || []);
        } else {
          setCustomers([])
        }
      } catch (error) {
        console.log('Failed to fetch customers:', error);
        setCustomers([]);
      } finally {
        setCustomersLoading(false);
      }
    };

    fetchCustomers();
  }, []);

  const fetchSalePersons = async () => {
    setSalePersonsLoading(true);
    try {
      const response = await getSalePersons();
      const users = response?.data || [];
      setSalePersons(users);
      const isSalePerson = userData?.role === 'Sale Person'
      if (isSalePerson) {
        const salePersonSelect = response?.data?.find((item) => {
          return (
            item?.adminUserId === userData?.adminUserId
          );
        });
        setOrder({
          ...order,
          handleBy: salePersonSelect?.adminUserId || null,
          salePersonName: salePersonSelect?.name || null,
        })
      }
    } catch (error) {
      console.error('Failed to fetch sale persons:', error);
      setSalePersons([]);
    } finally {
      setSalePersonsLoading(false);
    }
  };

  useEffect(() => {
    fetchSalePersons()
  }, [])

  const fetchOrder = async () => {
    try {
      const response = await getOrderById(orderId);
      let responseSalePersons;
      if (response?.success) {
        responseSalePersons = await getSalePersons();
      }
      const data = response?.data || {};
      if (data?.status) {
        data.status = Object.keys(orderStatus).find(key => orderStatus[key] === data.status) || data.status;
      }
      setDiscount(Number(data?.discount))
      setDiscountLabel(data?.discountLabel || "");
      const isSalePerson = userData?.role === 'Sale Person'

      // // NEW: Authorization check - Sale Person can only view orders assigned to them
      // if (isSalePerson && data?.handleBy && data?.handleBy !== userData?.adminUserId) {
      //   navigate('/orders');
      //   return;
      // }

      const salePersonSelect = responseSalePersons?.data?.find((item) => {
        return (
          item?.adminUserId === userData?.adminUserId ||
          item?.adminUserId === response?.data?.handleBy
        );
      });

      const orderData = {
        ...data,
        handleBy: salePersonSelect?.adminUserId || null,
        salePersonName: salePersonSelect?.name || null,
        expectedDeliveryDate: data?.expectedDeliveryDate || order?.expectedDeliveryDate,
        driverName: data?.driverName || "",
        driverMobileNumber: data?.driverMobileNumber || "",
        driverVehicleNo: data?.driverVehicleNo || "",
        customer: {
          customerId: data?.customerData?.customerId,
          name: data?.customerData?.name || "",
          email: data?.customerData?.email || "",
          mobileNumber: data?.customerData?.mobileNumber !== undefined ? data?.customerData?.mobileNumber : null,
        }
      }
      setOrder(orderData);
      setOrderNotes(data?.activities || [])

    } catch (error) {
      console.log('Failed to fetch order:', error);
      setOrder({});
    } finally {
    }
  };

  useEffect(() => {

    if (orderId && orderId !== undefined && orderId !== '') {
      fetchOrder();
    }
  }, [orderId]);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await getProductsWithTax();
        setProductsList(response?.data || []);
      } catch (error) {
        console.log('Failed to fetch products:', error);
        setProductsList([]);
      } finally {
      }
    };

    fetchProducts();
  }, []);

  useEffect(() => {
    if (isNew) {
      setIsCheckingAccess(false);
      setIsAccessDenied(false);
      return;
    }

    // For existing orders, verify access
    const checkOrderAccess = async () => {
      try {
        const orderData = await getOrderById(orderId);

        if (userRole === 'Sale Person' || userRole === 'sales_person') {
          if (orderData?.data?.handleBy !== userId) {
            setIsAccessDenied(true);
            setIsCheckingAccess(false);
            return;
          }
        }

        setIsAccessDenied(false);
        setIsCheckingAccess(false);
      } catch (error) {
        console.error('Error checking order access:', error);
        setIsAccessDenied(true);
        setIsCheckingAccess(false);
      }
    };

    checkOrderAccess();
  }, [orderId, userRole, userId]);

  if (isCheckingAccess) {
    return null; // or return <Loader />
  }

  if (isAccessDenied) {
    return <ErrorPage />;
  }

  // Handle enter key for line total
  const handleLineTotalKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleLineTotalSave();
    } else if (e.key === 'Escape') {
      setEditingLineTotal(null);
      setTempLineTotal('');
    }
  };

  // Handle enter key for unit cost
  const handleUnitCostKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleUnitCostSave();
    } else if (e.key === 'Escape') {
      setEditingUnitCostId(null);
      setTempUnitCost('');
    }
  };

  const handleDiscountKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleDiscountSave();
    } else if (e.key === 'Escape') {
      setEditingDiscount(null);
      setTempDiscount('');
    }
  };

  // Handle enter key for quantity
  const handleQtyKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleQtySave();
    } else if (e.key === 'Escape') {
      setEditingProductId(null);
      setTempQty('');
    }
  };

  const validate = () => {
    const newErrors = {};

    if (isNew) {
      if (!order.customer) newErrors.customer = 'Customer is required';
    } else {
      const customerErrors = {};

      if (!order?.customer?.name?.trim()) {
        customerErrors.name = 'Customer name is required';
      }

      if (!order?.customer?.email?.trim()) {
        customerErrors.email = 'Customer email is required';
      }

      if (order?.customer?.mobileNumber === "" || !order?.customer?.mobileNumber || order?.customer?.mobileNumber === undefined) {
        customerErrors.mobileNumber = 'Customer mobile number is required';
      }

      // Only attach customer errors if any exist
      if (Object.keys(customerErrors).length > 0) {
        newErrors.customer = customerErrors;
      }
    }

    if (order?.products?.length === 0) newErrors.products = 'At least add 1 product';

    const billing = order?.billingAddress || {};
    const shipping = order?.shippingAddress || {};

    const addressField = [
      { key: 'firstName', label: 'First name' },
      { key: 'lastName', label: 'Last name' },
      { key: 'address', label: 'Address' },
      { key: 'city', label: 'City' },
      // { key: 'state', label: 'State' },
      { key: 'zipCode', label: 'Zip code' },
      // { key: 'country', label: 'Country' },
      { key: 'phone', label: 'Phone' },
      // { key: 'email', label: 'Email' },
    ];

    const missingBillingFields = addressField.filter(
      field => !billing[field.key]?.trim()
    );
    const missingShippingFields = addressField.filter(
      field => !shipping[field.key]?.trim()
    );

    // 👉 VIEW MODE (isBillingAddress === false)
    if (!isBillingAddress && missingBillingFields.length > 0) {
      newErrors.billingAddressSummary =
        `Please add ${missingBillingFields.map(f => f.label).join(', ')}`;
    }
    if (isBillingAddress) {
      if (!order.billingAddress?.firstName?.trim()) newErrors.billingFirstName = 'First name is required';
      if (!order.billingAddress?.lastName?.trim()) newErrors.billingLastName = 'Last name is required';
      if (!order.billingAddress?.address?.trim()) newErrors.billingAddress = 'Address is required';
      if (!order.billingAddress?.city?.trim()) newErrors.billingCity = 'City is required';
      if (order?.billingAddress?.gst?.trim() &&
        !/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/.test(order?.billingAddress?.gst?.trim().toUpperCase()))
        newErrors.billingGst = "Enter valid GST number (e.g. 22AAAAA0000A1Z5)";

      // PAN validation (optional field)
      if (order?.billingAddress?.pan?.trim() &&
        !/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(order?.billingAddress?.pan?.trim().toUpperCase()))
        newErrors.billingPan = "Enter valid PAN number (e.g. AAAAA0000A)";
      // if (!order.billingAddress?.state?.trim()) newErrors.billingState = 'State is required';
      if (!order.billingAddress?.zipCode?.trim()) newErrors.billingZipCode = 'Zip code is required';
      else if (!/^\d+$/.test(order.billingAddress.zipCode)) newErrors.billingZipCode = 'Zip code must be numeric';
      if (!order.billingAddress?.phone?.trim()) newErrors.billingPhone = 'Phone is required';
      else if (!/^\d+$/.test(order.billingAddress.phone)) newErrors.billingPhone = 'Phone must be numeric';
      // if (!order.billingAddress?.email?.trim()) newErrors.billingEmail = 'Email is required';
      else if ((!/\S+@\S+\.\S+/.test(order.billingAddress.email) && (order.billingAddress.email))) newErrors.billingEmail = 'Invalid email format';
    }

    if (!isShippingAddress && missingShippingFields.length > 0) {
      newErrors.shippingAddressSummary =
        `Please add ${missingShippingFields.map(f => f.label).join(', ')}`;
    }
    if (isShippingAddress) {
      if (!order.shippingAddress?.firstName?.trim()) newErrors.shippingFirstName = 'First name is required';
      if (!order.shippingAddress?.lastName?.trim()) newErrors.shippingLastName = 'Last name is required';
      if (!order.shippingAddress?.address?.trim()) newErrors.shippingAddress = 'Address is required';
      if (!order.shippingAddress?.city?.trim()) newErrors.shippingCity = 'City is required';
      // if (!order.shippingAddress?.state?.trim()) newErrors.shippingState = 'State is required';
      if (!order.shippingAddress?.zipCode?.trim()) newErrors.shippingZipCode = 'Zip code is required';
      else if (!/^\d+$/.test(order.shippingAddress.zipCode)) newErrors.shippingZipCode = 'Zip code must be numeric';
      if (!order.shippingAddress?.phone?.trim()) newErrors.shippingPhone = 'Phone is required';
      else if (!/^\d+$/.test(order.shippingAddress.phone)) newErrors.shippingPhone = 'Phone must be numeric';
      // if (!order.shippingAddress?.email?.trim()) newErrors.shippingEmail = 'Email is required';
      if (!(/\S+@\S+\.\S+/.test(order.shippingAddress.email)) && (order.shippingAddress?.email?.trim())) newErrors.shippingEmail = 'Invalid email format';
    }

    // Date validation
    if (moment(order.expectedDeliveryDate).isBefore(moment(order.orderCreatedDate))) {
      newErrors.expectedDeliveryDate = 'Expected delivery date must be after order created date';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleCreate = async () => {
    if (!validate()) return;

    try {
      setIsLoading(true)

      // Generate PDF blob
      let invoiceFile = null;
      if (invoicePdfRef.current) {
        const pdfBlob = await invoicePdfRef.current.generatePDFBlob();
        if (pdfBlob) {
          invoiceFile = new File([pdfBlob], `Invoice-${order?.orderId || 'new'}.pdf`, { type: 'application/pdf' });
        }
      }

      const createData = {
        ...order,
        customer: undefined,
        customerId: order?.customer?.customerId,
        handleBy: order?.handleBy || null,
        driverName: order?.driverName || "",
        driverMobileNumber: order?.driverMobileNumber || "",
        driverVehicleNo: order?.driverVehicleNo || "",
        products: order?.products?.map((p) => {
          const lineTotal = p?.lineTotal || 0; // base total
          const cgstAmount = lineTotal * ((p.cgst || 0) / 100);
          const sgstAmount = lineTotal * ((p.sgst || 0) / 100);
          const igstAmount = lineTotal * ((p.igst || 0) / 100);
          const totalWithTax = lineTotal + cgstAmount + sgstAmount + igstAmount;

          return {
            ...p,
            total: totalWithTax,
            productId: p?.productId,
            unitCost: p?.unitCost || 0
          };
        }),
        discount: discount || 0,
        discountLabel: discountLabel || "",
        refund: order?.refund || 0,
        shippingAddress: order?.shippingAddress || {},
        billingAddress: order?.billingAddress || {},
        expectedDeliveryDate: order?.expectedDeliveryDate,
        status: order?.status || 'pending',
      };

      // Create FormData for file upload
      const formData = new FormData();
      formData.append('data', JSON.stringify(createData));
      if (invoiceFile) {
        formData.append('invoice', invoiceFile);
      }

      const response = await createOrder(formData);
      // if (response?.success) {
      setIsLoading(false)
      setIsBillingAddress(false)
      setIsShippingAddress(false)
      navigate(`/order/${response?.data?.orderId}`);
      // }

    } catch (error) {
      console.error('Failed to create order:', error);
      setIsLoading(false)
    }
  };

  const handleSendDeliveryVerification = async () => {
    const newErrors = {};
    const driverName = order?.driverName?.trim();
    if (!driverName) {
      newErrors.driverName = 'Driver name is required';
    }
    const driverMobile = order?.driverMobileNumber?.trim();
    if (!driverMobile) {
      newErrors.driverMobileNumber = 'Driver mobile number is required';
    } else if (!/^\d{10}$/.test(driverMobile)) {
      newErrors.driverMobileNumber = 'Driver mobile number must be exactly 10 digits';
    }
    setErrors(newErrors);

    const errorObject = Object.keys(newErrors).length === 0;

    if (!errorObject) return;
    try {

      setDeliveryVerificationLoader(true)

      const response = await sendDeliveryVerification(orderId, order?.driverName, order?.driverMobileNumber, order?.driverVehicleNo)
      console.log({ response })
      if (response?.success) {
        setDeliveryVerificationLoader(false)
      }
    } catch (error) {
      console.error('Failed to update order:', error);
      setDeliveryVerificationLoader(false)
    }
  }

  const handleUpdate = async () => {
    if (!validate()) return;

    try {
      setIsLoading(true)

      // Generate PDF blob
      let invoiceFile = null;
      if (invoicePdfRef.current) {
        const pdfBlob = await invoicePdfRef.current.generatePDFBlob();
        if (pdfBlob) {
          invoiceFile = new File([pdfBlob], `Invoice-${order?.orderId}.pdf`, { type: 'application/pdf' });
        }
      }

      const updateData = {
        ...order,
        customer: undefined,
        driverName: order?.driverName || "",
        driverMobileNumber: order?.driverMobileNumber || "",
        driverVehicleNo: order?.driverVehicleNo || "",
        customerData: {
          name: order?.customer?.name || "",
          email: order?.customer?.email || "",
          mobileNumber: order?.customer?.mobileNumber || "",
        },
        products: order?.products?.map((p) => {
          const lineTotal = p?.lineTotal || 0; // base total
          const cgstAmount = lineTotal * ((p.cgst || 0) / 100);
          const sgstAmount = lineTotal * ((p.sgst || 0) / 100);
          const igstAmount = lineTotal * ((p.igst || 0) / 100);
          const totalWithTax = lineTotal + cgstAmount + sgstAmount + igstAmount;

          return {
            ...p,
            total: totalWithTax,
            unitCost: p?.unitCost || 0
          };
        }),
        discount: discount,
        discountLabel: discountLabel || "",
        refund: order?.refund,
        shippingAddress: order?.shippingAddress,
        billingAddress: order?.billingAddress,
        expectedDeliveryDate: order?.expectedDeliveryDate,
        status: order?.status,
        mediaId: undefined,
        image: undefined
      };

      // Create FormData for file upload
      const formData = new FormData();
      formData.append('data', JSON.stringify(updateData));
      if (invoiceFile) {
        formData.append('invoice', invoiceFile);
      }

      const response = await updateOrder(order?.orderId, formData);
      if (response?.success) {
        setIsLoading(false)
        setIsBillingAddress(false)
        setIsShippingAddress(false)
        setOrderNotes(response?.data?.activities || [])
      }
    } catch (error) {
      console.error('Failed to update order:', error);
      setIsLoading(false)
    }
  };

  const deleteOrderItem = (productId) => {
    setOrder(prev => ({
      ...prev,
      products: prev.products.filter(p => p.id !== productId)
    }));
    setShowDeletePopup(false)
  };

  const productTotal = order?.products?.reduce((sum, item) => sum + (item?.lineTotal || 0), 0)
  const discountAmount = discount || 0;

  const taxAmount = order?.products?.reduce((sum, item) => {
    const cgstAmount = (item?.lineTotal * (item?.cgst || 0)) / 100;
    const sgstAmount = (item?.lineTotal * (item?.sgst || 0)) / 100;
    const igstAmount = (item?.lineTotal * (item?.igst || 0)) / 100;
    return sum + cgstAmount + sgstAmount + igstAmount;
  }, 0) || 0;
  // SubTotal is the sum of product totals (without tax)
  const subTotal = productTotal === undefined ? 0 : productTotal;
  // Final total = SubTotal + Tax - Discount
  const finalTotal = subTotal + taxAmount - discountAmount;

  const renderAddressView = (address) => {
    if (!address || Object.keys(address).length === 0) return null;

    return (
      <div className={styles.addressBox}>
        <p className={styles.label}>Address:</p>
        <p className={styles.value}>
          {/* {address.firstName} {address.lastName}<br /> */}
          {address.address}, {address.city} - {address.zipCode} {address.state !== '' ? `,${address.state}` : ''} <br />
          {/* {address.country}<br /> */}
          {
            address?.email !== '' &&
            <>
              <p className={styles.label}>Email:</p>
              Email: {address.email}<br />
            </>
          }
          {(address?.gst !== "" && address?.gst !== undefined) ? <><p className={styles.label}>GST: </p>{address?.gst}<br /></> : null}
          {(address?.pan !== "" && address?.pan !== undefined) ? <><p className={styles.label}>PAN: </p>{address?.pan}<br /></> : null}
          {address.companyName && <><p className={styles.label}>Company:</p> {address.companyName}</>}
        </p>
      </div>
    );
  };

  const confirmDelete = async () => {
    try {
      const response = await deleteOrders([orderId]);
      if (response?.success) {
        navigate('/orders');
      }
    } catch (error) {
      console.log(error);
    }
  }

  const handleNotifyCustomer = async () => {
    try {
      setCustomerNotifyLoader(true)
      const response = await notifyCustomer(orderId)
      if (response?.success) {
        setCustomerNotifyLoader(false)
      }
    } catch (error) {
      setCustomerNotifyLoader(false)
    }
    setCustomerNotificationSent(true)
    await fetchOrder()
  }

  const handleNotifyCustomerToEmail = async () => {
    try {
      setCustomerNotifyLoaderForEmail(true)
      const response = await notifyCustomerToEmail(orderId)
      if (response?.success) {
        setCustomerNotifyLoaderForEmail(false)
      }
    } catch (error) {
      setCustomerNotifyLoaderForEmail(false)
    }
    setCustomerNotificationSentToEmail(true)
    await fetchOrder()
  }

  const handleNotifyCustomerToWhatsapp = async () => {
    try {
      setCustomerNotifyLoaderForWhatsapp(true)
      const response = await notifyCustomerToWhatsapp(orderId)
      if (response?.success) {
        setCustomerNotifyLoaderForWhatsapp(false)
      }
    } catch (error) {
      setCustomerNotifyLoaderForWhatsapp(false)
    }
    setCustomerNotificationSentToWhatsapp(true)
    await fetchOrder()
  }

  return (
    <div className={styles.orderDetail}>
      <TopBar />
      {/* <div className={styles.container}> */}
      <div className={styles.newpageContent} >
        <div className={styles.newpageLeft}>
          <div className={`${styles.newpageLeftRow}`}>
            <div className={styles.orderDetailPageTopBar}>
              <h1 className={styles.title}>{isNew ? 'New Order' : `Order Details - ${orderId}`}</h1>
            </div>
            <div className={styles.orderDetailSection}>
              {/* General Section */}
              <div className={styles.section}>
                <h2 className={styles.sectionTitle}>General</h2>
                <div className={styles.generalGrid}>
                  <div className={styles.field}>
                    <label className={styles.label}>Date Created</label>
                    <div className={styles.dateTimeWrapper}>

                      {/* DATE INPUT */}
                      <input
                        type="date"
                        className={styles.input}
                        min={today}
                        value={moment(order?.orderCreatedDate).format("YYYY-MM-DD")}
                        onChange={(e) => {
                          const updated = moment(order?.orderCreatedDate)
                            .set({
                              year: moment(e.target.value).year(),
                              month: moment(e.target.value).month(),
                              date: moment(e.target.value).date(),
                            })
                            .toISOString();
                          setOrder(prev => ({ ...prev, orderCreatedDate: updated }));
                        }}
                      />@

                      {/* HOUR INPUT */}
                      <input
                        type="number"
                        min="0"
                        max="23"
                        className={styles.timeInput}
                        value={moment(order?.orderCreatedDate).format("HH")}
                        onChange={(e) => {
                          const updated = moment(order?.orderCreatedDate)
                            .set({ hour: e.target.value })
                            .toISOString();
                          setOrder(prev => ({ ...prev, orderCreatedDate: updated }));
                        }}
                      />:

                      {/* MINUTE INPUT */}
                      <input
                        type="number"
                        min="0"
                        max="59"
                        className={styles.timeInput}
                        value={moment(order?.orderCreatedDate).format("mm")}
                        onChange={(e) => {
                          const updated = moment(order?.orderCreatedDate)
                            .set({ minute: e.target.value })
                            .toISOString();
                          setOrder(prev => ({ ...prev, orderCreatedDate: updated }));
                        }}
                      />

                    </div>
                  </div>

                  <div className={styles.field}>
                    <label className={styles.label}>Expected Delivery Date</label>
                    <div className={styles.dateTimeWrapper}>

                      {/* DATE INPUT */}
                      <input
                        type="date"
                        className={styles.input}
                        min={today}
                        value={moment(order?.expectedDeliveryDate).format("YYYY-MM-DD")}
                        onChange={(e) => {
                          const updated = moment(order?.expectedDeliveryDate)
                            .set({
                              year: moment(e.target.value).year(),
                              month: moment(e.target.value).month(),
                              date: moment(e.target.value).date(),
                            })
                            .toISOString();
                          setOrder(prev => ({ ...prev, expectedDeliveryDate: updated }));
                        }}
                      />@

                      {/* HOUR INPUT */}
                      <input
                        type="number"
                        min="0"
                        max="23"
                        className={styles.timeInput}
                        value={moment(order?.expectedDeliveryDate).format("HH")}
                        onChange={(e) => {
                          const updated = moment(order?.expectedDeliveryDate)
                            .set({ hour: e.target.value })
                            .toISOString();
                          setOrder(prev => ({ ...prev, expectedDeliveryDate: updated }));
                        }}
                      />:

                      {/* MINUTE INPUT */}
                      <input
                        type="number"
                        min="0"
                        max="59"
                        className={styles.timeInput}
                        value={moment(order?.expectedDeliveryDate).format("mm")}
                        onChange={(e) => {
                          const updated = moment(order?.expectedDeliveryDate)
                            .set({ minute: e.target.value })
                            .toISOString();
                          setOrder(prev => ({ ...prev, expectedDeliveryDate: updated }));
                        }}
                      />

                    </div>
                    {errors.expectedDeliveryDate && <span className="error-message">{errors.expectedDeliveryDate}</span>}
                  </div>

                  <div className={styles.field}>
                    <label className={styles.label}>Status</label>
                    <div className="dropdown-wrapper order-dropdown" ref={statusDropdownRef}>
                      <div className="dropdown-header" onClick={() => setOpenStatus(!openStatus)}>
                        <span className="title">{orderStatus[order?.status] || "Status"}</span>
                        <span className={`arrow ${openStatus ? "rotate" : ""}`}><img src={down} alt='down-icon' /></span>
                      </div>
                      {openStatus && (
                        <div className="dropdown-list" >
                          {Object.entries(orderStatus).map(([key, label]) => (
                            <label
                              key={key}
                              className="dropdown-item"
                              onClick={() => {
                                setOrder(prev => ({ ...prev, status: key })); // Save API value
                                setOpenStatus(false);
                                setErrors({ ...errors, status: '' });
                              }}
                            >
                              <span>{label}</span>
                            </label>
                          ))}
                        </div>
                      )}
                    </div>
                    {errors.status && <span className="error-message">{errors.status}</span>}
                  </div>
                  <div className={styles.field}>
                    <label className={styles.label}>Customer</label>
                    {
                      isNew ?
                        <div className="dropdown-wrapper order-dropdown" ref={brandDropdownRef}>
                          <div className="dropdown-header customer-list-header" onClick={() => !customersLoading && setOpenCustomer(!openCustomer)}>
                            <div>
                              {order?.customer?.name || order?.customerData?.name || "Select Customer"}
                              {(order?.customer?.email || order?.customerData?.email) && <span>{`(${order?.customer?.email || order?.customerData?.email})`}</span>}
                            </div>
                            <span className={`arrow ${openCustomer ? "rotate" : ""}`}><img src={down} alt='down-icon' /></span>
                          </div>

                          {openCustomer && !customersLoading && (
                            <div className="dropdown-list">
                              <input
                                type="text"
                                className="dropdown-search"
                                placeholder="Search customer..."
                                value={customerSearch}
                                onChange={(e) => setCustomerSearch(e.target.value)}
                                onClick={(e) => e.stopPropagation()}
                                autoFocus
                              />
                              {(() => {
                                const searchValue = customerSearch.trim().toLowerCase();

                                const filteredCustomers =
                                  searchValue === ""
                                    ? customers
                                    : customers.filter((item) => {
                                      const name = item?.name?.toLowerCase() || "";
                                      const email = item?.email?.toLowerCase() || "";
                                      const mobileNumber = String(item?.mobileNumber || "");

                                      return (
                                        name.includes(searchValue) ||
                                        email.includes(searchValue) ||
                                        mobileNumber.includes(customerSearch.trim())
                                      );
                                    });

                                return filteredCustomers.length === 0 ? (
                                  <div className="dropdown-item">No customer found</div>
                                ) : (
                                  filteredCustomers.map((item, index) => (
                                    <label
                                      key={index}
                                      className="dropdown-item customer-list-dropdown"
                                      onClick={() => {
                                        setOrder((prev) => ({
                                          ...prev,
                                          customer: item,
                                        }));
                                        setOpenCustomer(false);
                                        setCustomerSearch("");
                                        setErrors({
                                          ...errors,
                                          customer: "",
                                        });
                                      }}
                                    >
                                      <span>{item?.name}</span>
                                    </label>
                                  ))
                                );
                              })()}
                            </div>
                          )}
                        </div>
                        :
                        <div className={styles.addressBox}>
                          <p className={styles.label}>Name:</p>
                          <p className={styles.value}>
                            {order?.customer?.name}
                          </p>
                          <p className={styles.label}>Email:</p>
                          <p className={styles.value}>
                            {order?.customer?.email}
                          </p>
                          <p className={styles.label}>Mobile Number:</p>
                          <p className={styles.value}>
                            {order?.customer?.mobileNumber}
                          </p>
                        </div>
                    }
                    {(errors.customer && isNew) && <span className="error-message">{errors.customer}</span>}
                  </div>
                </div>
              </div>
              <div className={styles.addressSection}>
                <div className={styles.section}>
                  <div className={styles.sectionTitle}>
                    <span>Billing Address</span>

                    {/* EDIT / CLOSE ICON */}
                    <div onClick={() => setIsBillingAddress(!isBillingAddress)}>
                      <img src={isBillingAddress ? close : penIcon} alt="icon" />
                    </div>
                  </div>

                  {/* VIEW MODE */}
                  {!isBillingAddress && order?.billingAddress && Object.keys(order.billingAddress).length > 0 &&
                    <>
                      {renderAddressView(order.billingAddress)}
                      {!isBillingAddress && errors.billingAddressSummary &&
                        <>
                          <p className="error-message">
                            {errors.billingAddressSummary}
                          </p>
                        </>
                      }
                    </>
                  }

                  {/* EMPTY STATE */}
                  {!isBillingAddress && (!order?.billingAddress || Object.keys(order.billingAddress).length === 0) && (
                    <div className={styles.addressBox}>
                      <p className={styles.label}>Address:</p>
                      <p className={styles.value}>No billing address set.</p>
                      {!isBillingAddress && errors.billingAddressSummary &&
                        <>
                          <p className="error-message">
                            {errors.billingAddressSummary}
                          </p>
                        </>
                      }
                    </div>
                  )}

                  {isBillingAddress && (
                    <div className={styles.addressGrid}>
                      <div>
                        <p className={styles.label}>First name</p>
                        <input
                          className={styles.input}
                          placeholder="First Name"
                          value={order?.billingAddress?.firstName || ""}
                          onChange={(e) => { handleBillingChange("firstName", e.target.value); setErrors({ ...errors, billingFirstName: '' }); }}
                        />
                        {errors.billingFirstName && <span className="error-message">{errors.billingFirstName}</span>}
                      </div>
                      <div>
                        <p className={styles.label}>Last name</p>
                        <input
                          className={styles.input}
                          placeholder="Last Name"
                          value={order?.billingAddress?.lastName || ""}
                          onChange={(e) => { handleBillingChange("lastName", e.target.value); setErrors({ ...errors, billingLastName: '' }); }}
                        />
                        {errors.billingLastName && <span className="error-message">{errors.billingLastName}</span>}
                      </div>
                      <div>
                        <p className={styles.label}>Address</p>
                        <input
                          className={styles.input}
                          placeholder="Address"
                          value={order?.billingAddress?.address || ""}
                          onChange={(e) => { handleBillingChange("address", e.target.value); setErrors({ ...errors, billingAddress: '' }); }}
                        />
                        {errors.billingAddress && <span className="error-message">{errors.billingAddress}</span>}
                      </div>
                      <div>
                        <p className={styles.label}>City</p>
                        <input
                          className={styles.input}
                          placeholder="City"
                          value={order?.billingAddress?.city || ""}
                          onChange={(e) => { handleBillingChange("city", e.target.value); setErrors({ ...errors, billingCity: '' }); }}
                        />
                        {errors.billingCity && <span className="error-message">{errors.billingCity}</span>}
                      </div>
                      <div>
                        <p className={styles.label}>State</p>
                        <input
                          className={styles.input}
                          placeholder="State"
                          value={order?.billingAddress?.state || ""}
                          onChange={(e) => { handleBillingChange("state", e.target.value); setErrors({ ...errors, billingState: '' }); }}
                        />
                        {/* {errors.billingState && <span className="error-message">{errors.billingState}</span>} */}
                      </div>
                      <div>
                        <p className={styles.label}>Zip code</p>
                        <input
                          className={styles.input}
                          placeholder="Zip Code"
                          value={order?.billingAddress?.zipCode || ""}
                          onChange={(e) => { handleBillingChange("zipCode", e.target.value); setErrors({ ...errors, billingZipCode: '' }); }}
                        />
                        {errors.billingZipCode && <span className="error-message">{errors.billingZipCode}</span>}
                      </div>
                      {/* <div>
                        <p className={styles.label}>Country</p>
                        <input
                          className={styles.input}
                          placeholder="Country"
                          value={order?.billingAddress?.country || ""}
                          onChange={(e) => { handleBillingChange("country", e.target.value); setErrors({ ...errors, billingCountry: '' }); }}
                        />
                        {errors.billingCountry && <span className="error-message">{errors.billingCountry}</span>}
                      </div> */}
                      <div>
                        <p className={styles.label}>Phone</p>
                        <input
                          className={styles.input}
                          placeholder="Phone"
                          value={order?.billingAddress?.phone || ""}
                          onChange={(e) => { handleBillingChange("phone", e.target.value); setErrors({ ...errors, billingPhone: '' }); }}
                        />
                        {errors.billingPhone && <span className="error-message">{errors.billingPhone}</span>}
                      </div>
                      <div>
                        <p className={styles.label}>Email</p>
                        <input
                          className={styles.input}
                          placeholder="Email"
                          value={order?.billingAddress?.email || ""}
                          onChange={(e) => { handleBillingChange("email", e.target.value); setErrors({ ...errors, billingEmail: '' }); }}
                        />
                        {errors.billingEmail && <span className="error-message">{errors.billingEmail}</span>}
                      </div>
                      <div>
                        <p className={styles.label}>Company name(Optional)</p>
                        <input
                          className={styles.input}
                          placeholder="Company Name"
                          value={order?.billingAddress?.companyName || ""}
                          onChange={(e) => { handleBillingChange("companyName", e.target.value) }}
                        />
                      </div>
                      <div>
                        <p className={styles.label}>GST Number(Optional)</p>
                        <input
                          className={styles.input}
                          placeholder="GST Number"
                          value={order?.billingAddress?.gst || ""}
                          onChange={(e) => { handleBillingChange("gst", e.target.value); setErrors({ ...errors, billingGst: '' }); }}
                        />
                        {errors.billingGst && <span className="error-message">{errors.billingGst}</span>}
                      </div>
                      <div>
                        <p className={styles.label}>PAN Number(Optional)</p>
                        <input
                          className={styles.input}
                          placeholder="Pan number"
                          value={order?.billingAddress?.pan || ""}
                          onChange={(e) => { handleBillingChange("pan", e.target.value); setErrors({ ...errors, billingPan: '' }); }}
                        />
                        {errors.billingPan && <span className="error-message">{errors.billingPan}</span>}
                      </div>
                    </div>
                  )}
                </div>


                {/* Shipping Address Section */}
                <div className={styles.section}>
                  <div className={styles.sectionTitle}>
                    <span>Shipping Address</span>

                    {/* EDIT / CLOSE ICON */}
                    <div onClick={() => setIsShippingAddress(!isShippingAddress)}>
                      <img src={isShippingAddress ? close : penIcon} alt="icon" />
                    </div>
                  </div>

                  {/* VIEW MODE */}
                  {!isShippingAddress &&
                    order?.shippingAddress &&
                    Object.keys(order.shippingAddress).length > 0 &&
                    <>
                      {renderAddressView(order.shippingAddress)}
                      {!isShippingAddress && errors.shippingAddressSummary &&
                        <>
                          <p className="error-message">
                            {errors.shippingAddressSummary}
                          </p>
                        </>
                      }
                    </>
                  }

                  {/* EMPTY STATE */}
                  {!isShippingAddress &&
                    (!order?.shippingAddress ||
                      Object.keys(order.shippingAddress).length === 0) && (
                      <div className={styles.addressBox}>
                        <p className={styles.label}>Address:</p>
                        <p className={styles.value}>No shipping address set.</p>
                        {!isShippingAddress && errors.shippingAddressSummary &&
                          <>
                            <p className="error-message">
                              {errors.shippingAddressSummary}
                            </p>
                          </>
                        }
                      </div>
                    )}

                  {/* EDIT MODE */}
                  {isShippingAddress && (
                    <div className={styles.addressGrid}>
                      <div>
                        <p className={styles.label}>First name</p>
                        <input
                          className={styles.input}
                          placeholder="First Name"
                          value={order?.shippingAddress?.firstName || ""}
                          onChange={(e) => {
                            handleShippingChange("firstName", e.target.value);
                            setErrors({ ...errors, shippingFirstName: '' });
                          }}
                        />
                        {errors.shippingFirstName && <span className="error-message">{errors.shippingFirstName}</span>}
                      </div>
                      <div>
                        <p className={styles.label}>Last name</p>
                        <input
                          className={styles.input}
                          placeholder="Last Name"
                          value={order?.shippingAddress?.lastName || ""}
                          onChange={(e) => {
                            handleShippingChange("lastName", e.target.value);
                            setErrors({ ...errors, shippingLastName: '' });
                          }}
                        />
                        {errors.shippingLastName && <span className="error-message">{errors.shippingLastName}</span>}
                      </div>
                      <div>
                        <p className={styles.label}>Address</p>
                        <input
                          className={styles.input}
                          placeholder="Address"
                          value={order?.shippingAddress?.address || ""}
                          onChange={(e) => {
                            handleShippingChange("address", e.target.value);
                            setErrors({ ...errors, shippingAddress: '' });
                          }}
                        />
                        {errors.shippingAddress && <span className="error-message">{errors.shippingAddress}</span>}
                      </div>
                      <div>
                        <p className={styles.label}>City</p>
                        <input
                          className={styles.input}
                          placeholder="City"
                          value={order?.shippingAddress?.city || ""}
                          onChange={(e) => {
                            handleShippingChange("city", e.target.value);
                            setErrors({ ...errors, shippingCity: '' });
                          }}
                        />
                        {errors.shippingCity && <span className="error-message">{errors.shippingCity}</span>}
                      </div>
                      <div>
                        <p className={styles.label}>State</p>
                        <input
                          className={styles.input}
                          placeholder="State"
                          value={order?.shippingAddress?.state || ""}
                          onChange={(e) => {
                            handleShippingChange("state", e.target.value);
                            setErrors({ ...errors, shippingState: '' });
                          }}
                        />
                        {/* {errors.shippingState && <span className="error-message">{errors.shippingState}</span>} */}
                      </div>
                      <div>
                        <p className={styles.label}>Zip code</p>
                        <input
                          className={styles.input}
                          placeholder="Zip Code"
                          value={order?.shippingAddress?.zipCode || ""}
                          onChange={(e) => {
                            handleShippingChange("zipCode", e.target.value);
                            setErrors({ ...errors, shippingZipCode: '' });
                          }}
                        />
                        {errors.shippingZipCode && <span className="error-message">{errors.shippingZipCode}</span>}
                      </div>
                      {/* <div>
                        <p className={styles.label}>Country</p>
                        <input
                          className={styles.input}
                          placeholder="Country"
                          value={order?.shippingAddress?.country || ""}
                          onChange={(e) => {
                            handleShippingChange("country", e.target.value);
                            setErrors({ ...errors, shippingCountry: '' });
                          }}
                        />
                        {errors.shippingCountry && <span className="error-message">{errors.shippingCountry}</span>}
                      </div> */}
                      <div>
                        <p className={styles.label}>Phone</p>
                        <input
                          className={styles.input}
                          placeholder="Phone"
                          value={order?.shippingAddress?.phone || ""}
                          onChange={(e) => {
                            handleShippingChange("phone", e.target.value)
                            setErrors({ ...errors, shippingPhone: '' });
                          }
                          }
                        />
                        {errors.shippingPhone && <span className="error-message">{errors.shippingPhone}</span>}
                      </div>
                      <div>
                        <p className={styles.label}>Email</p>
                        <input
                          className={styles.input}
                          placeholder="Email"
                          value={order?.shippingAddress?.email || ""}
                          onChange={(e) => {
                            handleShippingChange("email", e.target.value)
                            setErrors({ ...errors, shippingEmail: '' });
                          }
                          }
                        />
                        {errors.shippingEmail && <span className="error-message">{errors.shippingEmail}</span>}
                      </div>
                      <div>
                        <p className={styles.label}>Company name(Optional)</p>

                        <input
                          className={styles.input}
                          placeholder="Company Name"
                          value={order?.shippingAddress?.companyName || ""}
                          onChange={(e) =>
                            handleShippingChange("companyName", e.target.value)
                          }
                        />
                      </div>
                    </div>
                  )}
                </div>

              </div>
              {/* Billing Address Section */}
            </div>
            <div className={styles.section}>
              <h2 className={styles.sectionTitle}>Products</h2>
              <table className={styles.productsTable}>
                <thead>
                  <tr>
                    <th>Item</th>
                    <th>Quantity</th>
                    <th>CGST</th>
                    <th>SGST</th>
                    <th>IGST</th>
                    <th>Unit Cost</th>
                    <th>Line Total</th>
                    <th>Total</th>
                    <th style={{ textAlign: 'right' }}>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    order?.products?.length > 0 ?
                      <>
                        {order?.products?.map(product => (
                          <tr key={product.id}>
                            <td>{product.item}</td>
                            <td
                              onDoubleClick={() => handleQtyDoubleClick(product?.id, product?.quantity)}
                              className={styles.qtyCell}
                              style={
                                editingProductId === product.id
                                  ? { paddingTop: 0, paddingBottom: 0 }
                                  : undefined
                              }
                            >
                              {editingProductId === product.id ? (
                                <input
                                  ref={qtyRef}
                                  type="number"
                                  min="0.01"
                                  step="0.01"
                                  className={styles.qtyInput}
                                  value={tempQty}
                                  onChange={handleQtyChange}
                                  onKeyDown={handleQtyKeyPress}
                                  autoFocus
                                />
                              ) : (
                                product.quantity
                              )}
                            </td>

                            <td onDoubleClick={() => handleCgstDoubleClick(product.id, product.cgst)}>
                              {editingCgstId === product.id ? (
                                <input
                                  ref={cgstRef}
                                  type="number"
                                  value={tempCgst}
                                  onChange={handleCgstChange}
                                  // onBlur={handleCgstSave}
                                  onKeyDown={(e) => e.key === 'Enter' && handleCgstSave()}
                                  autoFocus
                                  className={styles.qtyInput}
                                />
                              ) : (
                                `${product.cgst || 0}%`
                              )}
                            </td>
                            <td onDoubleClick={() => handleSgstDoubleClick(product.id, product.sgst)}>
                              {editingSgstId === product.id ? (
                                <input
                                  type="number"
                                  ref={sgstRef}
                                  value={tempSgst}
                                  onChange={handleSgstChange}
                                  // onBlur={handleSgstSave}
                                  onKeyDown={(e) => e.key === 'Enter' && handleSgstSave()}
                                  autoFocus
                                  className={styles.qtyInput}
                                />
                              ) : (
                                `${product.sgst || 0}%`
                              )}
                            </td>
                            <td onDoubleClick={() => handleIgstDoubleClick(product.id, product.igst)}>
                              {editingIgstId === product.id ? (
                                <input
                                  type="number"
                                  ref={igstRef}
                                  value={tempIgst}
                                  onChange={handleIgstChange}
                                  // onBlur={handleIgstSave}
                                  onKeyDown={(e) => e.key === 'Enter' && handleIgstSave()}
                                  autoFocus
                                  className={styles.qtyInput}
                                />
                              ) : (
                                `${product.igst || 0}%`
                              )}
                            </td>
                            <td
                              onDoubleClick={() => handleUnitCostDoubleClick(product?.id, product?.unitCost)}
                              className={styles.totalCell}
                              style={
                                editingUnitCostId === product.id
                                  ? { paddingTop: 0, paddingBottom: 0 }
                                  : undefined
                              }
                            >
                              {editingUnitCostId === product.id ? (
                                <input
                                  ref={unitCostRef}
                                  type="number"
                                  step="0.01"
                                  min="0"
                                  className={styles.totalInput}
                                  value={tempUnitCost}
                                  onChange={handleUnitCostChange}
                                  onKeyDown={handleUnitCostKeyPress}
                                  autoFocus
                                />
                              ) : (
                                `₹${product?.unitCost?.toFixed(2) || '0.00'}`
                              )}
                            </td>
                            <td className={styles.totalCell}>
                              {`₹${product?.lineTotal?.toFixed(2)}`}
                            </td>
                            <td className={styles.totalCell}>
                              {`₹${(product?.lineTotal + (product?.lineTotal * (product?.cgst || 0) / 100) + (product?.lineTotal * (product?.sgst || 0) / 100) + (product?.lineTotal * (product?.igst || 0) / 100)).toFixed(2)}`}
                            </td>
                            <td className={styles.actionButtons}>
                              {editingProductId === product.id && editingItemRow ? (
                                <button className={styles.actionButton} onClick={saveItemEdit} ref={rowSaveRef}>
                                  <img src={save} alt="save-icon" />
                                </button>
                              ) : (
                                <button
                                  className={styles.actionButton}
                                  onClick={() => itemEdit(product)}
                                >
                                  <img src={penIcon} alt="pen-icon" />
                                </button>
                              )}

                              <button className={styles.actionButton}
                                onClick={() => {
                                  setDeleteType("item");
                                  setDeleteItemId(product.id);
                                  setDeleteItemName(product.item);
                                  setShowDeletePopup(true);
                                }}>
                                <img src={Delete} alt="delete" />
                              </button>
                            </td>
                          </tr>
                        ))}
                      </> :
                      <tr>
                        <td colSpan={9}>No Data found</td>
                      </tr>
                  }
                </tbody>
                <tfoot className={styles.productsTableFooter}>
                  <tr>
                    <td className={styles.productAddSection}>
                      <button
                        className={styles.productAddBtn}
                        onClick={() => {
                          setAddNewProduct(true);
                          setProductsToAdd([{ search: "", selectedProduct: null, openDropdown: false, qty: "", unit: "", unitCost: "", hsnCode: "", cgst: 0, sgst: 0, igst: 0, categoryName: '', productId: '', unit: "", unitPlural: "", }]);
                          setProductErrors([]);
                        }}
                      >
                        {order?.products?.length > 1 ? 'Add item(s)' : 'Add Product(s)'}
                      </button>
                      {
                        order?.products?.length > 0 &&
                        <>
                          {/* <button className={styles.productAddBtn} onClick={() => setShowRefundPopup(true)}>
                            Refund
                          </button> */}

                          {discount === 0 && (
                            <button
                              className={styles.productAddBtn}
                              onClick={() => setShowDiscountPopup(true)}
                            >
                              Add Discount
                            </button>
                          )}
                        </>
                      }

                    </td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>

                    {(order?.products?.length > 0) ? (
                      <td className={styles.totalAmountWithDiscount} colSpan={3}>
                        <div className={styles.totalAmountWithDiscountDiv}>

                          <div className={styles.totalRow}>
                            <span className={styles.label}>SubTotal:</span>
                            <span className={styles.footerValue}>₹{subTotal?.toFixed(2)}</span>
                          </div>

                          <div className={styles.totalRow}>
                            <span className={styles.label}>CGST:</span>
                            <span className={styles.footerValue}>₹{(order?.products?.reduce((sum, item) => sum + ((item?.lineTotal * (item?.cgst || 0)) / 100), 0))?.toFixed(2)}</span>
                          </div>

                          <div className={styles.totalRow}>
                            <span className={styles.label}>SGST:</span>
                            <span className={styles.footerValue}>₹{(order?.products?.reduce((sum, item) => sum + ((item?.lineTotal * (item?.sgst || 0)) / 100), 0))?.toFixed(2)}</span>
                          </div>

                          <div className={styles.totalRow}>
                            <span className={styles.label}>IGST:</span>
                            <span className={styles.footerValue}>₹{(order?.products?.reduce((sum, item) => sum + ((item?.lineTotal * (item?.igst || 0)) / 100), 0))?.toFixed(2)}</span>
                          </div>

                          {(discount > 0 && order?.products?.length > 0) && (
                            <div
                              className={styles.totalRow}
                              onDoubleClick={handleDiscountDoubleClick}
                              style={{ cursor: "pointer" }}
                            >
                              <span className={styles.label}>{(order?.discountLabel !== undefined && order?.discountLabel !== "") ? order?.discountLabel : "Discount"}:</span>

                              {editingDiscount ? (
                                <input
                                  ref={discountRef}
                                  type="number"
                                  min="0"
                                  max={subTotal + taxAmount}
                                  value={tempDiscount}
                                  onChange={(e) => setTempDiscount(e.target.value)}
                                  onKeyDown={handleDiscountKeyPress}
                                  autoFocus
                                  className={styles.totalInput}
                                />
                              ) : (
                                <span className={styles.footerValue}>
                                  {discount > 0 ? `- ₹${Number(discount)?.toFixed(2)}` : "₹0.00"}
                                </span>
                              )}
                            </div>
                          )}

                          <div className={styles.totalRow}>
                            <span className={styles.label}><strong>Total:</strong></span>
                            <span className={styles.footerValue}><strong>₹{finalTotal?.toFixed(2)}</strong></span>
                          </div>

                        </div>
                      </td>
                    ) : (
                      <td className={styles.totalAmount} colSpan={3}>
                        <div>
                          <strong>Total:</strong> ₹0.00
                        </div>
                      </td>
                    )}

                    <td></td>

                  </tr>
                </tfoot>

              </table>
              {errors.products && <span className="error-message">{errors.products}</span>}
            </div>
          </div>
        </div>
        <div className={`${styles.newpageRight}`}>
          <div className={styles.buttonsDesktop}>
            <div className={styles.newpageRightButtons}>
              <button className={`${styles.addBtn} ${!isNew ? `${styles.updateOrderbtn}` : `${styles.addOrderBtn}`}`} onClick={isNew ? handleCreate : handleUpdate}>
                {
                  isLoading ?
                    <div className={`ringLoader loaderContinue`}></div> :
                    <p>{isNew ? 'Save' : 'Update'}</p>
                }
              </button>
              {
                !isNew &&
                <button className={styles.addBtn}
                  onClick={() => {
                    setDeleteType("order");
                    setShowDeletePopup(true);
                  }}>
                  <p>Delete</p>
                </button>
              }
              <InvoicePDF ref={invoicePdfRef} order={order} styles={styles} />
            </div>

          </div>
          {/* Sale Person Section */}
          <div className={`${styles.newPageRightRow} ${styles.sendMailOrderDropdown}`} ref={salePersonDropdownRef} style={{ pointerEvents: userData?.role === 'Sale Person' ? 'none' : 'auto' }}>
            <div
              className={`${styles.newPageRightTitle} ${styles.iconDropWrap}`}
              onClick={() => setOpenSalePerson(!openSalePerson)}
            >
              <span>Sale Person</span>
              <div className={styles.dropdownIcon}>
                <img src={iconDropDown} className={openSalePerson ? styles.rotateIcon : ""} alt='icon' />
              </div>
            </div>

            <div className={`${styles.contentDrop} ${openSalePerson ? styles.expanded : styles.collapse}`} >
              <div className={styles.driverMobileWrapper}>
                <div className="dropdown-wrapper order-dropdown" onClick={() => !salePersonsLoading && setOpenSalePersonDropdown(!openSalePersonDropdown)}>
                  <div className="dropdown-header customer-list-header">
                    <div>
                      {order?.salePersonName || order?.salePerson?.name || "Select Sale Person"}
                    </div>
                    <span className={`arrow ${openSalePersonDropdown ? "rotate" : ""}`}><img src={down} alt='down-icon' /></span>
                  </div>
                  {openSalePersonDropdown && (
                    <div className="dropdown-list">
                      {salePersonsLoading ? (
                        <div className="dropdown-item">Loading...</div>
                      ) : (
                        salePersons?.map((item, index) => (
                          <label
                            key={index}
                            className="dropdown-item customer-list-dropdown"
                            onClick={() => {
                              setOrder((prev) => ({
                                ...prev,
                                handleBy: item?.adminUserId,
                                salePersonName: item?.name,
                              }));
                              setOpenSalePersonDropdown(false);
                            }}
                          >
                            <span>{item?.name} </span>
                            {/* <span>({item?.email})</span> */}
                          </label>
                        ))
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* Driver Mobile Number Section */}
          <div className={`${styles.newPageRightRow} ${styles.sendMailOrderDropdown}`}>
            <div
              className={`${styles.newPageRightTitle} ${styles.iconDropWrap}`}
              onClick={() => setOpenDriverMobile(!openDriverMobile)}
            >
              <span>Driver Information</span>
              <div className={styles.dropdownIcon}>
                <img src={iconDropDown} alt="dropdown" />
              </div>
            </div>

            <div className={`${styles.contentDrop} ${openDriverMobile ? styles.expanded : styles.collapse}`}>
              <div className={styles.driverMobileWrapper}>
                <label className={styles.label}>Driver Name</label>
                <input
                  type="text"
                  className={styles.input}
                  placeholder="Enter driver name"
                  value={order?.driverName || ""}
                  onChange={(e) => {
                    setOrder(prev => ({ ...prev, driverName: e.target.value }));
                    setErrors({ ...errors, driverName: '' });
                  }}
                />
                {errors.driverName && <span className="error-message">{errors.driverName}</span>}
              </div>
              <div className={styles.driverMobileWrapper}>
                <label className={styles.label}>Driver Mobile Number</label>
                <input
                  type="tel"
                  className={styles.input}
                  placeholder="Enter 10 digit mobile number"
                  maxLength={10}
                  value={order?.driverMobileNumber || ""}
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, '');
                    setOrder(prev => ({ ...prev, driverMobileNumber: value }));
                    setErrors({ ...errors, driverMobileNumber: '' });
                  }}
                />
                {errors.driverMobileNumber && <span className="error-message">{errors.driverMobileNumber}</span>}
              </div>
              <div className={styles.driverMobileWrapper}>
                <label className={styles.label}>Driver Vehicle No</label>
                <input
                  type="text"
                  className={styles.input}
                  placeholder="Enter Driver Vehicle Number"
                  value={order?.driverVehicleNo || ""}
                  onChange={(e) => {
                    const value = e.target.value
                    setOrder(prev => ({ ...prev, driverVehicleNo: value }));
                  }}
                />
              </div>
            </div>
            <button className={`${styles.addBtn} ${styles.deliveryVerificationBtn}`} onClick={() => handleSendDeliveryVerification()} disabled={deliveryVerificationLoader}>
              {
                deliveryVerificationLoader ?
                  <div className={`ringLoader loaderContinue`}></div> :
                  <p>Delivery Verification</p>
              }
            </button>
          </div>

          <div className={`${styles.newPageRightRow} ${styles.sendMailOrderDropdown}`} >
            <div className={`${styles.newPageRightTitle} ${styles.iconDropWrap}`} onClick={toggleDropdownSendMailImage}>
              <span>Send order email and whatsapp notification</span>
              <div className={styles.dropdownIcon}>
                <img src={iconDropDown} alt="dropdown" />
              </div>
            </div>
            <div className={`${styles.contentDrop} ${isOpenSendMailDropdown ? `${styles.expanded}` : `${styles.collapse}`}`}>
              <div className={`${styles.adressInputBlock} ${styles.urlInput} ${styles.customerNotificationButton}`}>
                <button className={styles.addBtn} onClick={() => handleNotifyCustomer()} disabled={customerNotifyLoader}>
                  {
                    customerNotifyLoader ?
                      <div className={`ringLoader loaderContinue`}></div> :
                      <p>{customerNotificationSent ? 'Quotation sent' : 'Notify customer'}</p>
                  }
                </button>
              </div>
              <div className={`${styles.adressInputBlock} ${styles.urlInput}`}>
                <button className={styles.addBtn} onClick={() => handleNotifyCustomerToEmail()} disabled={customerNotifyLoaderForEmail}>
                  {
                    customerNotifyLoaderForEmail ?
                      <div className={`ringLoader loaderContinue`}></div> :
                      <p>{customerNotificationSentToEmail ? 'Email Sent' : 'Send to Email'}</p>
                  }
                </button>
                <button className={styles.addBtn} onClick={() => handleNotifyCustomerToWhatsapp()} disabled={customerNotifyLoaderForWhatsapp}>
                  {
                    customerNotifyLoaderForWhatsapp ?
                      <div className={`ringLoader loaderContinue`}></div> :
                      <p>{customerNotificationSentToWhatsapp ? 'WhatsApp Sent' : 'Send to WhatsApp'}</p>
                  }
                </button>
              </div>
            </div>
          </div>

          {/* Order Image Upload By User Section */}
          <div className={`${styles.newPageRightRow} ${styles.sendMailOrderDropdown}`}>
            <div
              className={`${styles.newPageRightTitle} ${styles.iconDropWrap}`}
              onClick={() => setOpenOrderImage(!openOrderImage)}
            >
              <span>Order Image Uploaded By User</span>
              <div className={styles.dropdownIcon}>
                <img src={iconDropDown} className={openOrderImage ? styles.rotateIcon : ""} alt='icon' />
              </div>
            </div>

            <div className={`${styles.contentDrop} ${openOrderImage ? styles.expanded : styles.collapse}`}>
              {order?.image?.url ? (
                <div className={styles.orderImageWrapper}>
                  <img
                    src={order.image.url}
                    alt="Order uploaded by user"
                    className={styles.orderUserImage}
                    onClick={() => setShowImagePopup(true)}
                  />
                </div>
              ) : (
                <p className={styles.noImageText}>No image uploaded by user</p>
              )}
            </div>
          </div>

          <div className={`${styles.newPageRightRow} ${styles.sendMailOrderDropdown}`}>
            <div
              className={`${styles.newPageRightTitle} ${styles.iconDropWrap}`}
              onClick={() => setOpenOrderNotes(!openOrderNotes)}
            >
              <span>Order Notes</span>
              <div className={styles.dropdownIcon}>
                <img src={iconDropDown} className={openOrderNotes ? styles.rotateIcon : ""} alt='icon' />
              </div>
            </div>

            <div className={`${styles.contentDrop} ${openOrderNotes ? styles.expanded : styles.collapse}`}>
              <div className={styles.orderNotesWrapper}>
                {orderNotes.map((note) => (
                  <div key={note.id} className={styles.orderNoteBox}>
                    <p className={styles.noteMessage}>{note.message}</p>
                    <p className={styles.noteDate}>{formattedDateTime(note.createdAt)}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className={styles.buttonsMobile}>
            <div className={styles.newpageRightButtons}>
              <button className={styles.addBtn} onClick={isNew ? handleCreate : handleUpdate}>
                <p>{isNew ? 'Save' : 'Update'}</p>
              </button>
              <button className={styles.addBtn}
                onClick={() => {
                  setDeleteType("order");
                  setShowDeletePopup(true);
                }}>
                <p>Delete</p>
              </button>
              <InvoicePDF ref={invoicePdfRef} order={order} styles={styles} />
            </div>

          </div>
        </div>
      </div>
      <DeleteConfirmationPopup
        showDeletePopup={showDeletePopup}
        setShowDeletePopup={setShowDeletePopup}
        reference={popupRef}
        title={deleteType === "order" ? "Order" : "Item"}
        description={
          deleteType === "order"
            ? `Are you sure you want to delete order ${orderId}?`
            : `Are you sure you want to remove ${deleteItemName} from order?`
        }
        confirmDelete={() => {
          if (deleteType === "order") {
            confirmDelete()
          } else {
            deleteOrderItem(deleteItemId); // delete item only
          }
        }}
      />
      <AddProduct
        reference={addProductDropdownRef}
        productsList={productsList}
        setAddNewProduct={setAddNewProduct}
        addNewProduct={addNewProduct}
        setOrder={setOrder}
        productsToAdd={productsToAdd}
        setProductsToAdd={setProductsToAdd}
        productErrors={productErrors}
        setProductErrors={setProductErrors}
        setErrors={setErrors}
        errors={errors}
      />

      <RefundPopup
        reference={refundPopupRef}
        show={showRefundPopup}
        onClose={() => setShowRefundPopup(false)}
        refundType={refundType}
        setRefundType={setRefundType}
        refundAmount={refundAmount}
        setRefundAmount={setRefundAmount}
        refundReason={refundReason}
        setRefundReason={setRefundReason}
        refundReasonOptions={refundReasonOptions}
        finalTotal={finalTotal}
        openRefundReason={openRefundReason}
        setOpenRefundReason={setOpenRefundReason}
        styles={styles}
        onSubmit={() => {
          setShowRefundPopup(false);
        }}
      />

      <DiscountPopup
        reference={discountPopupRef}
        show={showDiscountPopup}
        onClose={() => setShowDiscountPopup(false)}
        discount={discount}
        setDiscount={setDiscount}
        discountType={discountType}
        setDiscountType={setDiscountType}
        finalTotal={finalTotal}
        onSubmit={() => setShowDiscountPopup(false)}
        styles={styles}
        discountLabel={discountLabel}
        setDiscountLabel={setDiscountLabel}
      />

      {/* Order Image Popup */}
      {
        showImagePopup && order?.image?.url && (
          <div className={styles.imagePopupOverlay} onClick={() => setShowImagePopup(false)}>
            <div
              className={styles.imagePopupContent}
              ref={imagePopupRef}
              onClick={(e) => e.stopPropagation()}
            >
              <button
                className={styles.imagePopupClose}
                onClick={() => setShowImagePopup(false)}
              >
                <img src={close} alt="Close" />
              </button>
              <img
                src={order.image.url}
                alt="Order uploaded by user"
                className={styles.imagePopupImage}
              />
            </div>
          </div>
        )
      }
    </div >
  );
};

export default OrderDetail;